// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.clear-row {
  display: flex;
  cursor: pointer;
  align-items: center;
  width: 100%;
  justify-content: flex-end;
}
.clear-row a {
  color: #fff;
  display: flex;
  align-items: center;
  gap: 4px;
}
.clear-row a span {
  cursor: pointer;
  position: relative;
  top: -2px;
}

.close {
  background: none;
  display: block;
  border: none;
  font-size: 1em;
  color: black;
  cursor: pointer;
}

.action-button {
  background-color: #ff4747;
  border: none;
  padding: 5px 10px;
  color: white;
  border-radius: 5px;
  cursor: pointer;
  margin-top: 10px;
}

.av-icon {
  display: flex;
  min-width: 41px;
  height: 41px;
  justify-content: center;
  align-items: center;
}

.push-alert {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 440px;
  padding: 20px;
  background-color: #fff;
  box-shadow: 0 4px 4px rgba(0, 0, 0, 0.12);
  border-radius: 10px;
  margin-bottom: 15px;
  cursor: pointer;
}
.push-alert.success .push-title {
  color: #4caf50;
}
.push-alert.success .avtar-ic {
  background-color: #4caf50;
  color: #fff;
}
.push-alert.danger .push-title {
  color: #fd2d3a;
}
.push-alert.danger .avtar-ic {
  background-color: #fd2d3a;
  color: #fff;
}
.push-alert .avtar-ic {
  display: flex;
  min-width: 48px;
  height: 48px;
  background-color: #e2e8f0;
  color: #73839b;
  align-items: center;
  justify-content: center;
  border-radius: 30px;
  text-transform: uppercase;
}
.push-alert .pust-desc {
  display: flex;
  flex-flow: column;
  gap: 5px;
}
.push-alert .pust-desc .push-title {
  font-size: 16px;
  font-weight: 600;
}
.push-alert .pust-desc .push-body p {
  font-size: 16px;
  font-weight: 400;
  margin: 0;
}
.push-alert .pust-desc .push-body p a {
  color: #fd2d3a;
  text-decoration: none;
}

.annouoncement-alert {
  display: flex;
  flex-flow: column;
  align-items: center;
  gap: 10px;
  width: 440px;
  padding: 20px;
  background-color: #fff;
  box-shadow: 0 4px 4px rgba(0, 0, 0, 0.12);
  border-radius: 10px;
  margin-bottom: 15px;
}
.annouoncement-alert.success .avtar-ic {
  background-color: #4bb543 !important;
  color: #fff !important;
  border: 6px solid #c7f9c3;
}
.annouoncement-alert.success .annouoncement-title {
  color: #4bb543;
}
.annouoncement-alert.new .avtar-ic {
  background-color: #1dafba !important;
  color: #fff !important;
  border: 6px solid #bcf1f5;
}
.annouoncement-alert.new .annouoncement-title {
  color: #1dafba;
}
.annouoncement-alert .annouoncement-head {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}
.annouoncement-alert .annouoncement-head .avtar-ic {
  display: flex;
  min-width: 48px;
  height: 48px;
  background-color: #e2e8f0;
  color: #73839b;
  align-items: center;
  justify-content: center;
  border-radius: 50px;
  text-transform: uppercase;
}
.annouoncement-alert .annouoncement-desc {
  display: flex;
  flex-flow: column;
  gap: 5px;
}
.annouoncement-alert .annouoncement-desc .annouoncement-title {
  font-size: 16px;
  font-weight: 600;
}
.annouoncement-alert .annouoncement-desc .annouoncement-body p {
  font-size: 16px;
  font-weight: 400;
  margin: 0;
  color: #7d7d7d;
}
.annouoncement-alert .annouoncement-desc .annouoncement-body p a {
  color: #fd2d3a;
  text-decoration: none;
}

@media screen and (max-width: 500px) {
  .push-alert,
  .annouoncement-alert {
    width: 100%;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/recent-notification/recent-notifications.component.scss"],"names":[],"mappings":"AACA;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,WAAA;EACA,yBAAA;AAAF;AACE;EACE,WAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;AACJ;AAAI;EACE,eAAA;EACA,kBAAA;EACA,SAAA;AAEN;;AAGA;EACE,gBAAA;EACA,cAAA;EACA,YAAA;EACA,cAAA;EACA,YAAA;EACA,eAAA;AAAF;;AAIA;EACE,yBAAA;EACA,YAAA;EACA,iBAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;AADF;;AAKA;EACE,aAAA;EACA,eAAA;EACA,YAAA;EACA,uBAAA;EACA,mBAAA;AAFF;;AAKA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,yCAAA;EACA,mBAAA;EACA,mBAAA;EACA,eAAA;AAFF;AAKI;EACE,cAAA;AAHN;AAKI;EACE,yBAAA;EACA,WAAA;AAHN;AAQI;EACE,cAAA;AANN;AAQI;EACE,yBAAA;EACA,WAAA;AANN;AAUE;EACE,aAAA;EACA,eAAA;EACA,YAAA;EACA,yBAAA;EACA,cAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,yBAAA;AARJ;AAUE;EACE,aAAA;EACA,iBAAA;EACA,QAAA;AARJ;AAUI;EACE,eAAA;EACA,gBAAA;AARN;AAUI;EACE,eAAA;EACA,gBAAA;EACA,SAAA;AARN;AASM;EACE,cAAA;EACA,qBAAA;AAPR;;AAaA;EACE,aAAA;EACA,iBAAA;EACA,mBAAA;EACA,SAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,yCAAA;EACA,mBAAA;EACA,mBAAA;AAVF;AAaI;EACE,oCAAA;EACA,sBAAA;EACA,yBAAA;AAXN;AAaI;EACE,cAAA;AAXN;AAgBI;EACE,oCAAA;EACA,sBAAA;EACA,yBAAA;AAdN;AAgBI;EACE,cAAA;AAdN;AAkBE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,WAAA;AAhBJ;AAkBI;EACE,aAAA;EACA,eAAA;EACA,YAAA;EACA,yBAAA;EACA,cAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,yBAAA;AAhBN;AAoBE;EACE,aAAA;EACA,iBAAA;EACA,QAAA;AAlBJ;AAoBI;EACE,eAAA;EACA,gBAAA;AAlBN;AAqBM;EACE,eAAA;EACA,gBAAA;EACA,SAAA;EACA,cAAA;AAnBR;AAoBQ;EACE,cAAA;EACA,qBAAA;AAlBV;;AAwBA;EACE;;IAEE,WAAA;EArBF;AACF","sourcesContent":["\n.clear-row {\n  display: flex;\n  cursor: pointer;\n  align-items: center;\n  width: 100%;\n  justify-content: flex-end;\n  a {\n    color: #fff;\n    display: flex;\n    align-items: center;\n    gap: 4px;\n    span {\n      cursor: pointer;\n      position: relative;\n      top: -2px;\n    }\n  }\n}\n\n.close {\n  background: none;\n  display: block;\n  border: none;\n  font-size: 1em;\n  color: black;\n  cursor: pointer;\n}\n\n\n.action-button {\n  background-color: #ff4747;\n  border: none;\n  padding: 5px 10px;\n  color: white;\n  border-radius: 5px;\n  cursor: pointer;\n  margin-top: 10px;\n}\n\n\n.av-icon {\n  display: flex;\n  min-width: 41px;\n  height: 41px;\n  justify-content: center;\n  align-items: center;\n}\n\n.push-alert {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  width: 440px;\n  padding: 20px;\n  background-color: #fff;\n  box-shadow: 0 4px 4px rgba(0, 0, 0, 0.12);\n  border-radius: 10px;\n  margin-bottom: 15px;\n  cursor: pointer;\n\n  &.success {\n    .push-title {\n      color: #4caf50;\n    }\n    .avtar-ic {\n      background-color: #4caf50;\n      color: #fff;\n    }\n  }\n\n  &.danger {\n    .push-title {\n      color: #fd2d3a;\n    }\n    .avtar-ic {\n      background-color: #fd2d3a;\n      color: #fff;\n    }\n  }\n\n  .avtar-ic {\n    display: flex;\n    min-width: 48px;\n    height: 48px;\n    background-color: #e2e8f0;\n    color: #73839b;\n    align-items: center;\n    justify-content: center;\n    border-radius: 30px;\n    text-transform: uppercase;\n  }\n  .pust-desc {\n    display: flex;\n    flex-flow: column;\n    gap: 5px;\n\n    .push-title {\n      font-size: 16px;\n      font-weight: 600;\n    }\n    .push-body p {\n      font-size: 16px;\n      font-weight: 400;\n      margin: 0;\n      a {\n        color: #fd2d3a;\n        text-decoration: none;\n      }\n    }\n  }\n}\n\n.annouoncement-alert {\n  display: flex;\n  flex-flow: column;\n  align-items: center;\n  gap: 10px;\n  width: 440px;\n  padding: 20px;\n  background-color: #fff;\n  box-shadow: 0 4px 4px rgba(0, 0, 0, 0.12);\n  border-radius: 10px;\n  margin-bottom: 15px;\n\n  &.success {\n    .avtar-ic {\n      background-color: #4bb543 !important;\n      color: #fff !important;\n      border: 6px solid #c7f9c3;\n    }\n    .annouoncement-title {\n      color: #4bb543;\n    }\n  }\n\n  &.new {\n    .avtar-ic {\n      background-color: #1dafba !important;\n      color: #fff !important;\n      border: 6px solid #bcf1f5;\n    }\n    .annouoncement-title {\n      color: #1dafba;\n    }\n  }\n\n  .annouoncement-head {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    width: 100%;\n\n    .avtar-ic {\n      display: flex;\n      min-width: 48px;\n      height: 48px;\n      background-color: #e2e8f0;\n      color: #73839b;\n      align-items: center;\n      justify-content: center;\n      border-radius: 50px;\n      text-transform: uppercase;\n    }\n  }\n\n  .annouoncement-desc {\n    display: flex;\n    flex-flow: column;\n    gap: 5px;\n\n    .annouoncement-title {\n      font-size: 16px;\n      font-weight: 600;\n    }\n    .annouoncement-body {\n      p {\n        font-size: 16px;\n        font-weight: 400;\n        margin: 0;\n        color: #7d7d7d;\n        a {\n          color: #fd2d3a;\n          text-decoration: none;\n        }\n      }\n    }\n  }\n}\n@media screen and (max-width: 500px) {\n  .push-alert,\n  .annouoncement-alert {\n    width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
